<template>
    <template v-if="loading">
        <Loading />
    </template>

    <template v-else-if="errorMessage" class="error-message">
        <p>{{ errorMessage }}</p>
    </template>

    <template v-else>
        <div class="performance-list">
            <Performance
                v-for="performance in events"
                :key="performance.id"
                :performance="performance"
            />
        </div>
    </template>
</template>

<script setup>
import { onBeforeMount, ref } from 'vue';
import getPerformances from '../services/get-performances.mjs';
import Performance from './Performance.vue';

const props = defineProps({
    eventId: {
        type: String,
        required: true,
    }
});

const events = ref([]);
const loading = ref(true);
const errorMessage = ref(null);

onBeforeMount(async () => {
    try {
        events.value = await getPerformances()
            .then(perfs => perfs.filter(perf => perf.event.id === props.eventId));
    } catch (error) {
        console.error(error);
        errorMessage.value = 'Something has gone wrong, please try again later.';
        events.value = [];
    } finally {
        loading.value = false;
    }
});
</script>
